import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from "@angular/common";
import {ProductState} from "../../enums/product-state";
import {ProductStateLabel} from "../../enums/product-state-label";

@Component({
    selector: 'app-card',
    imports: [
      NgClass
    ],
    templateUrl: './card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './card.component.scss'
})
export class CardComponent {
  @Input() public header: string | null = null;
  @Input() public state: null | ProductState = null;
  @Input() public fullHeight: boolean = true;
  @Input() public disablePadding: boolean = false;

  protected readonly ProductState: typeof ProductState = ProductState;
  protected readonly ProductStateLabel: typeof ProductStateLabel = ProductStateLabel;
}
